import { render, staticRenderFns } from "./MyHeroes.vue?vue&type=template&id=68f02663&"
import script from "./MyHeroes.vue?vue&type=script&lang=js&"
export * from "./MyHeroes.vue?vue&type=script&lang=js&"
import style0 from "./MyHeroes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports